@if (gameSignal()) {
<div class="flex flex-col gap-6">
    <!-- Info -->
    <section class="flex flex-col gap-2">
        <div class="flex items-center justify-between gap-2 flex-wrap">
            <div class="font-semibold text-lg">Current state</div>
            <p-button
                label="Refresh"
                icon="pi pi-refresh"
                severity="secondary"
                [text]="true"
                size="small"
                [loading]="infoLoading()"
                (onClick)="reloadInfo()"
            />
        </div>

        @if (infoError()) {
        <p-message severity="error" [text]="infoError()!" styleClass="m-0" />
        } @else if (infoLoading() && !stats()) {
        <div class="text-sm text-muted-color">Loading…</div>
        } @else if (stats(); as s) {
        <div class="text-sm">
            <div class="mb-2">
                Total:
                <strong>{{ totalFake() }}</strong> fake ·
                <strong>{{ totalReal() }}</strong> real
            </div>
            <div
                class="grid grid-cols-5 gap-2 text-xs text-muted-color border border-surface-200 dark:border-surface-700 rounded p-2"
            >
                <div class="flex flex-col items-center">
                    <span>1★</span>
                    <span>
                        <strong class="text-color"
                            >{{ s.Rating1.FakeCount }}</strong
                        >
                        · {{ s.Rating1.RealCount }}
                    </span>
                </div>
                <div class="flex flex-col items-center">
                    <span>2★</span>
                    <span>
                        <strong class="text-color"
                            >{{ s.Rating2.FakeCount }}</strong
                        >
                        · {{ s.Rating2.RealCount }}
                    </span>
                </div>
                <div class="flex flex-col items-center">
                    <span>3★</span>
                    <span>
                        <strong class="text-color"
                            >{{ s.Rating3.FakeCount }}</strong
                        >
                        · {{ s.Rating3.RealCount }}
                    </span>
                </div>
                <div class="flex flex-col items-center">
                    <span>4★</span>
                    <span>
                        <strong class="text-color"
                            >{{ s.Rating4.FakeCount }}</strong
                        >
                        · {{ s.Rating4.RealCount }}
                    </span>
                </div>
                <div class="flex flex-col items-center">
                    <span>5★</span>
                    <span>
                        <strong class="text-color"
                            >{{ s.Rating5.FakeCount }}</strong
                        >
                        · {{ s.Rating5.RealCount }}
                    </span>
                </div>
            </div>
            <div class="text-xs text-muted-color mt-1">
                Format: <strong>fake</strong> · real
            </div>
        </div>
        }
    </section>

    <!-- Generate -->
    <section class="flex flex-col gap-3">
        <div class="font-semibold text-lg">Generate</div>

        <app-review-distribution-form
            [(targetAverage)]="targetAverage"
            [(count)]="count"
            [(concentration)]="concentration"
            [(createdFrom)]="createdFrom"
            [(createdTo)]="createdTo"
            [tags]="autoTags()"
            [validation]="poolValidation()"
            idPrefix="grp"
        />

        <div class="flex items-center gap-2 flex-wrap">
            <p-button
                label="Add"
                icon="pi pi-plus"
                [loading]="addBusy()"
                [disabled]="generateDisabled()"
                (onClick)="add()"
            />
            <p-button
                label="Replace all"
                icon="pi pi-refresh"
                severity="warn"
                [loading]="replaceBusy()"
                [disabled]="generateDisabled()"
                (onClick)="requestReplace()"
            />
            <p-button
                label="Remove all"
                icon="pi pi-trash"
                severity="danger"
                [loading]="removeAllBusy()"
                [disabled]="removeAllDisabled()"
                (onClick)="requestRemoveAll()"
            />
        </div>
    </section>
</div>
}

<p-dialog
    [visible]="replaceConfirmVisible()"
    (visibleChange)="replaceConfirmVisible.set($event)"
    header="Replace all fake reviews?"
    [modal]="true"
    [style]="{ width: '30rem' }"
    [draggable]="false"
    [resizable]="false"
>
    <p class="m-0 text-sm">
        This will remove the existing <strong>{{ totalFake() }}</strong> fake
        review(s) for this game and generate <strong>{{ count() }}</strong> new
        one(s) with the chosen parameters. Real reviews are not affected.
    </p>

    <ng-template #footer>
        <p-button
            label="Cancel"
            severity="secondary"
            [text]="true"
            (onClick)="cancelReplace()"
        />
        <p-button
            label="Replace"
            icon="pi pi-refresh"
            severity="warn"
            (onClick)="confirmReplace()"
        />
    </ng-template>
</p-dialog>

<p-dialog
    [visible]="removeAllConfirmVisible()"
    (visibleChange)="removeAllConfirmVisible.set($event)"
    header="Remove all fake reviews?"
    [modal]="true"
    [style]="{ width: '30rem' }"
    [draggable]="false"
    [resizable]="false"
>
    <p class="m-0 text-sm">
        This will permanently remove all
        <strong>{{ totalFake() }}</strong>
        fake review(s) for this game. Real reviews are not affected.
    </p>

    <ng-template #footer>
        <p-button
            label="Cancel"
            severity="secondary"
            [text]="true"
            (onClick)="cancelRemoveAll()"
        />
        <p-button
            label="Remove all"
            icon="pi pi-trash"
            severity="danger"
            (onClick)="confirmRemoveAll()"
        />
    </ng-template>
</p-dialog>
